import {createSlice} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";
import {favoriteVideoSuccess} from "store/reducer/video/favorite/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: {
        video: {},
        recent_video: {},
        category_video: {
            category: "",
            list: {}
        },
        events: {},
        cta: {},
        workouts: {},
        threads: {},
        users: {},
        companies: {}
    }
};

const slice = createSlice({
    name: "home",
    initialState,
    reducers: {
        getHomeDataStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        getHomeDataFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        getHomeDataSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.IDLE;
            state.data = payload
        }
    },
    extraReducers: {
        [favoriteVideoSuccess]: (state, {payload}) => {
            const {id, favorite} = payload;
            if(state.data.video[id]) state.data.video[id].favorite = favorite;
            if(state.data.recent_video[id]) state.data.recent_video[id].favorite = favorite;
            if(state.data.category_video.list[id]) state.data.category_video.list[id].favorite = favorite;
        }
    }
});

const {reducer, actions} = slice;

export const {
    getHomeDataStart, getHomeDataFailure, getHomeDataSuccess
} = actions;

export default reducer;
